

export const RestrictionLevel = {
  none: 'none',
  oneClub: 'oneclub',
  oneClubAdvantage: 'oneclubadvantage',
};
